
import { AdminTemplate, BankPaymentComponent  } from "../../components";

export const BankPayment = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
    <BankPaymentComponent/>
    </AdminTemplate>
  );
};
